export const scrollStep = 15;
export const scrollSpeed = 25;
export const scrollDistance = 200;
